import AuthGuard from 'app/auth/AuthGuard'
import NotFound from 'app/views/sessions/NotFound'
import dashboardRoutes from 'app/views/dashboard/DashboardRoutes'
import { exhibitorRoutesNoBottomBar, exhibitorRoutes, useRoleRoutes, RoleRedirect } from 'app/views/exhibitor/ExhibitorRoutes'
import sessionRoutes from 'app/views/sessions/SessionRoutes'
import MatxLayout from '../components/MatxLayout/MatxLayout'
import { Navigate } from 'react-router-dom'

export const AllPages = () => {
    const all_routes = [
        {
            element: (
                // <AuthGuard>
                    <MatxLayout showBottomNav/>
                // </AuthGuard>
            ),
            children: [...useRoleRoutes()],
        },
        // {
        //     element: (
        //         // <AuthGuard>
        //             <MatxLayout/>
        //         // </AuthGuard>
        //     ),
        //     children: [...exhibitorRoutesNoBottomBar],
        // },
        ...sessionRoutes,
        {
            path: '/',
            element: <RoleRedirect />,
        },
        {
            path: '*',
            element: <NotFound />,
        },
    ]

    return all_routes
}
